module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Anchor-right-up-4a8b9fc7753917b32f3b0ec2f1b3248c.svg";